module.exports = __webpack_public_path__ + "4f442dcbb6317b21b66aeea002052ab7.png";